import React from 'react';
import Link from 'next/link';
import { Card } from '../ui/Card';
import { SafeImage } from '../ui/SafeImage';

export function MovieCard({ movie, hasLyrics }) {
  if (!movie) return null;

  const isAvailable = movie.hasLyrics !== undefined ? movie.hasLyrics : (hasLyrics !== undefined ? hasLyrics : true);
  // Movie Cards strictly use Official Movie Poster Images
  const imageUrl = movie.posterUrl || movie.poster_path || movie.poster_url || movie.cover_image_url || movie.backdropUrl || movie.imageUrl || '/images/movies/fallback.svg';
  const movieTitle = movie.title || 'Movie Title';
  const movieLink = `/movie/${movie.slug || movie.id}`;

  const cardInner = (
    <Card className={`h-full border-none shadow-none bg-transparent ${isAvailable ? 'transition-transform duration-300 group-hover:scale-[1.02]' : 'opacity-90'}`}>
      <div className="relative aspect-[3/4] w-full overflow-hidden rounded-2xl bg-secondary/30 border border-border/50">
        <SafeImage
          src={imageUrl}
          title={movieTitle}
          subtitle={`${movie.year || 2026} Movie`}
          alt={`${movieTitle} Movie Poster`}
          fill
          className={`object-cover ${isAvailable ? 'group-hover:scale-105 transition-transform duration-500' : ''}`}
          sizes="(max-width: 768px) 50vw, (max-width: 1200px) 33vw, 20vw"
          placeholder="blur"
          blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />
        
        {!isAvailable && (
          <div className="absolute top-2.5 right-2.5 z-10">
            <span className="px-2 py-0.5 text-[10px] font-semibold tracking-wide uppercase bg-black/75 backdrop-blur-md text-amber-300 border border-amber-500/40 rounded-full shadow-sm">
              Lyrics Coming Soon
            </span>
          </div>
        )}

        <div className="absolute bottom-0 left-0 p-4 w-full text-white space-y-1">
          <h3 className="font-bold text-base md:text-lg leading-tight line-clamp-1">{movieTitle}</h3>
          <p className="text-xs md:text-sm text-gray-300">{movie.year || 2026} • <span className="capitalize">{movie.language || 'Tamil'}</span></p>
        </div>
      </div>
    </Card>
  );

  if (!isAvailable) {
    return <div className="block cursor-default select-none">{cardInner}</div>;
  }

  return (
    <Link href={movieLink} prefetch={false} className="block group">
      {cardInner}
    </Link>
  );
}
